import "./QuotationBanners.scss";

import usePermissions from "hooks/usePermissions";
import QuoteMultiDropBanner from "pages/common/QuotesDetail/components/QuoteMultiDropBanner/QuoteMultiDropBanner";
import QuoteTBQRBanner from "./QuoteTBQRBanner";
import QuoteRateCardBanner from "./QuoteRateCardBanner";

export default function QuotationBanners() {
  const { permissions } = usePermissions();
  const { user_type } = JSON.parse(permissions || "{}");

  const isShipper = user_type === "shipper";

  return (
    <div className="quotation-banners">
      <QuoteMultiDropBanner />
      {isShipper && (
        <>
          <QuoteTBQRBanner />
          <QuoteRateCardBanner />
        </>
      )}
    </div>
  );
}
